import React, { useState } from 'react';
import { Dialog, DialogTitle, Button, Box } from '@mui/material';

const ImageUpload = ({ open, onClose, onUpload }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleUpload = () => {
        if (selectedFile) {
            onUpload(selectedFile);
            setSelectedFile(null);
            setPreview(null);
            onClose();
        }
        window.location.reload();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>העלה כאן את הקובץ (תמונה)</DialogTitle>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '150px',
                    height: '150px',
                    border: '2px dashed #ccc',
                    borderRadius: '50%',
                    margin: '20px auto',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    backgroundColor: '#f9f9f9',
                }}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                {preview ? (
                    selectedFile.type.startsWith('video/') ? (
                        <Box
                            component="video"
                            src={preview}
                            controls
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '50%',
                            }}
                        />
                    ) : (
                        <Box
                            component="img"
                            src={preview}
                            alt="Preview"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '50%',
                            }}
                        />
                    )
                ) : (
                    <Box
                        sx={{
                            textAlign: 'center',
                            fontSize: '12px',
                            color: '#666',
                        }}
                    >
                        <p>העלה כאן</p>
                        <p>250x250 Min / 5 MB Max</p>
                    </Box>
                )}
                {/* Hidden file input that covers the container */}
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        cursor: 'pointer',
                    }}
                />
            </Box>
            <Box sx={{ textAlign: 'center', marginTop: '10px' }}>
                <Button
                    onClick={onClose}
                    sx={{
                        color: '#C4A484',
                        border: '1px solid #C4A484',
                        mr: '5px',
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleUpload}
                    disabled={!selectedFile}
                    variant="contained"
                    sx={{
                        marginBottom: '2px',
                        backgroundColor: '#C4A484',
                        '&:hover': { backgroundColor: '#C4A484' },
                    }}
                >
                    Upload
                </Button>
            </Box>
        </Dialog>
    );
};

export default ImageUpload;
